export const CROPSURE_PASSWORDS_LOAD_REQUESTED =
    'CROPSURE_PASSWORDS_LOAD_REQUESTED';
export const CROPSURE_PASSWORDS_LOAD_SUCCEEDED =
    'CROPSURE_PASSWORDS_LOAD_SUCCEEDED';
export const CROPSURE_PASSWORDS_LOAD_FAILED = 'CROPSURE_PASSWORDS_LOAD_FAILED';
export const CROPSURE_PASSWORDS_LOAD_CANCELED =
    'CROPSURE_PASSWORDS_LOAD_CANCELED';

export const CROPSURE_PASSWORD_CREATE_REQUESTED =
    'CROPSURE_PASSWORD_CREATE_REQUESTED';
export const CROPSURE_PASSWORD_CREATE_SUCCEEDED =
    'CROPSURE_PASSWORD_CREATE_SUCCEEDED';
export const CROPSURE_PASSWORD_CREATE_FAILED =
    'CROPSURE_PASSWORD_CREATE_FAILED';

export const CROPSURE_PASSWORD_UPDATE_REQUESTED =
    'CROPSURE_PASSWORD_UPDATE_REQUESTED';
export const CROPSURE_PASSWORD_UPDATE_SUCCEEDED =
    'CROPSURE_PASSWORD_UPDATE_SUCCEEDED';
export const CROPSURE_PASSWORD_UPDATE_FAILED =
    'CROPSURE_PASSWORD_UPDATE_FAILED';

export const CROPSURE_PASSWORD_DELETE_REQUESTED =
    'CROPSURE_PASSWORD_DELETE_REQUESTED';
export const CROPSURE_PASSWORD_DELETE_SUCCEEDED =
    'CROPSURE_PASSWORD_DELETE_SUCCEEDED';
export const CROPSURE_PASSWORD_DELETE_FAILED =
    'CROPSURE_PASSWORD_DELETE_FAILED';

export const CROPSURE_PASSWORDS_SET = 'CROPSURE_PASSWORDS_SET';
export const CROPSURE_PASSWORDS_DELETE = 'CROPSURE_PASSWORDS_DELETE';

export const CROPSURE_PASSWORDS_LOAD_NAMESPACE = 'CROPSURE_PASSWORDS_LOAD';
export const CROPSURE_PASSWORD_CREATE_NAMESPACE = 'CROPSURE_PASSWORD_CREATE';
export const CROPSURE_PASSWORD_UPDATE_NAMESPACE = 'CROPSURE_PASSWORD_UPDATE';
export const CROPSURE_PASSWORD_DELETE_NAMESPACE = 'CROPSURE_PASSWORD_DELETE';
